import Vue from 'vue'

// axios
import axios from 'axios'

import getEnv from '@/utils/env'

axios.defaults.baseURL = getEnv('VUE_APP_API_BASE_URL')

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: getEnv('VUE_APP_API_BASE_URL'),
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

Vue.prototype.$http = axiosIns

export default axiosIns
